import { defineComponent as f, createBlock as t, openBlock as o, Transition as u, mergeProps as d, withCtx as i, withDirectives as k, createCommentVNode as s, KeepAlive as v, normalizeProps as y, renderSlot as r, vShow as p } from "vue";
import l from "./TransitionableSlot.vue2.js";
const P = /* @__PURE__ */ f({
  __name: "TransitionContent",
  props: {
    keepAlive: { type: Boolean },
    keepAliveProps: {},
    transitionProps: {},
    renderBody: { type: Boolean },
    condition: { type: Boolean }
  },
  emits: ["leave"],
  setup(e) {
    return (n, a) => (o(), t(u, d(e.transitionProps, {
      onLeave: a[0] || (a[0] = (m) => n.$emit("leave", m))
    }), {
      default: i(() => [
        e.keepAlive ? (o(), t(v, y(d({ key: 0 }, e.keepAliveProps)), [
          e.condition ? (o(), t(l, { key: 0 }, {
            default: i(() => [
              r(n.$slots, "default")
            ]),
            _: 3
          })) : s("", !0)
        ], 1040)) : e.condition && !e.renderBody ? (o(), t(l, { key: 1 }, {
          default: i(() => [
            r(n.$slots, "default")
          ]),
          _: 3
        })) : e.renderBody ? k((o(), t(l, { key: 2 }, {
          default: i(() => [
            r(n.$slots, "default")
          ]),
          _: 3
        }, 512)), [
          [p, e.condition]
        ]) : s("", !0)
      ]),
      _: 3
    }, 16));
  }
});
export {
  P as default
};
